import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";
import invoiceLabels from "emun.invoice/_labels";
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config";
import emailInvoicePrompt from "emun.invoice/email-invoice-prompt";
import PrintInvoiceOptions from "emun.invoice/invoice-print";
import invoiceConfig from "emun.invoice/invoice.config";
import orderLabels from "emun.order/_labels";
import config from "emun.retailer/retailer.config";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import formSubmissionPrompt from "webforms/formio/formio-submission-prompt";
import actionList from "webmodals/action-list";
import modals from "webmodals/modals";

export default class InvoiceOneUpController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.labels = Object.assign({}, orderLabels, invoiceLabels);
    $ctrl.hideParcels = config.hideParcels === true;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    $ctrl.bus = new ServiceBus();
    $ctrl.invoiceConfig = invoiceConfig;
    $ctrl.creditRequestConfig = creditRequestConfig;
  }
  credit() {
    const $ctrl = this;
    const creditMemo = {
      //retailerId: $ctrl.invoice.retailerId,
      invoiceId: $ctrl.invoice.id,
      status: $ctrl.creditRequestConfig.creditRequestDefaultStatus || "Open",
      //reason: ""
    };

    $ctrl.bus
      .send("CreateCreditMemoRequest.json?jsconfig=ua,uaa", creditMemo)
      .then(
        (res) => $ctrl.onCreditMemoCreated(res.data),
        (res) => {
          if (res.data.responseStatus.errorCode == "CreditMemoRequestExists") {
            modals
              .confirm(
                "A credit request already exists for this invoice.  Would you like to open it?"
              )
              .result.then(function () {
                return $ctrl.$state.transitionTo("retailer.credit-request.detail", {
                  retailerId: $ctrl.invoice.retailerId,
                  creditRequestId: res.data.responseStatus.errors[0].fieldName,
                });
              });
          }
        }
      );

    //return creditMemoPrompt({
    //          retailerId: $ctrl.invoice.retailerId,
    //          model: {
    //              invoiceId: $ctrl.invoice.id,
    //              status: 'Open',
    //          }
    //      }).then(res => $ctrl.onCreditMemoCreated(res.data));
    //      return modals.prompt(
    //          `Request Credit: ${$ctrl.invoice.id}`, null, {
    //              label: 'Reason',
    //              okButtonLabel: 'Submit',
    //              placeholder: `Reason for credit/return?`,
    //          }).result
    //          .then(reason => {
    //              const creditMemo = {
    //                  retailerId: $ctrl.invoice.retailerId,
    //                  invoiceId: $ctrl.invoice.id,
    //                  status: 'Open',
    //                  reason
    //              };

    //              $ctrl.bus.send('CreateCreditMemoRequest.json?jsconfig=ua,uaa', creditMemo)
    //                  .then(res => $ctrl.onCreditMemoCreated(res.data));
    //          });
  }

  onCreditMemoCreated(creditMemo) {
    const $ctrl = this;
    return $ctrl.$state.transitionTo("retailer.credit-request", {
      retailerId: $ctrl.invoice.retailerId,
      creditRequestId: creditMemo.id,
    });
  }

  return(invoice) {
    const $ctrl = this;
    if (
      $ctrl.creditRequestConfig.invoiceAgeLimit && $ctrl.creditRequestConfig.invoiceAgeLimit > -1 &&
      moment($ctrl.invoice.invoiceDate).isBefore(
        moment().subtract($ctrl.creditRequestConfig.invoiceAgeLimit, "day")
      )
    ) {
      const returnActions = {
        "Contact Customer Service": {
          icon: "envelope",
          body: "Contact Customer Service",
          handler: () => {
            formSubmissionPrompt(
              Object.assign({
                title: "Contact Us by Email",
                formioId: "Contact Us",
              })
            );
          },
        },
        Cancel: {
          icon: "close",
          body: "Cancel claim request",
          handler: () => false,
        },
      };
      return actionList({
        title: `Claim Request`,
        body: `This invoice is more than ${$ctrl.creditRequestConfig.invoiceAgeLimit} days old.  To submit a claim please contact customer service for review`,
        actions: returnActions,
        size: "md",
      }).then((a) => a.handler());
    } else {
      $ctrl.credit();
    }
  }

  printInvoice(invoice) {
    const $ctrl = this;
    return PrintInvoiceOptions({
      request: {
        id: invoice,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }

  emailInvoice(invoice) {
    const $ctrl = this;
    return emailInvoicePrompt({
      id: invoice,
      invoiceNumber: invoice,
      from: $ctrl.$session.email,
      to: $ctrl.invoice.retailerEmail,
      subject: $ctrl.$session.clientName + " Invoice #" + invoice,
      clientName: $ctrl.$session.clientName,
      status: $ctrl.invoice.status,
      IncludeImages: false,
      IncludeBarcodes: false,
      OrderBy: "strProductID",
    });
  }

  exportToExcel(withImages) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=InvoiceExport&displayName=InvoiceExport&includeImages=" +
        withImages +
        "&output=xlsx&invoiceNumber=" +
        $ctrl.invoice.id
    );
    return (location.href = url);
  }

  downloadImagesPrompt(ext) {
    const $ctrl = this;
    return DownloadImagesPrompt({
      subTitle: $ctrl.invoice.id + " - " + $ctrl.invoice.companyName,
      productIds: $ctrl.invoice.lines.map((m) => m.productId),
      id: $ctrl.invoice.id,
    });
  }

  downloadPrompt(item) {
    console.info("item", item);
    return DownloadImagesPrompt({
      subTitle: item.productId + " - " + item.description,
      id: item.id,
      productId: item.productId,
      position: item.position,
    });
  }
}
